import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';

const ProductCard = ({ product, index = 0 }) => {
  const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist();
  const inWishlist = isInWishlist(product.id);

  const handleWishlistClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inWishlist) {
      removeFromWishlist(product.id);
    } else {
      addToWishlist(product);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-10%' }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="group relative"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`}>
        {/* Image Container */}
        <div className="product-image-container relative aspect-[3/4] bg-black/10 overflow-hidden">
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />

          {/* Overlay on hover */}
          <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
            <span className="btn-secondary text-xs">
              Voir le produit
            </span>
          </div>

          {/* Badges */}
          <div className="absolute top-4 left-4 flex flex-col gap-2">
            {product.is_new && (
              <span className="font-accent text-[10px] uppercase tracking-wider bg-gold text-black px-3 py-1">
                Nouveau
              </span>
            )}
            {product.stock < 5 && product.stock > 0 && (
              <span className="font-accent text-[10px] uppercase tracking-wider bg-kabyle-red text-white px-3 py-1">
                Stock limité
              </span>
            )}
          </div>

          {/* Wishlist Button */}
          <button
            onClick={handleWishlistClick}
            className={`absolute top-4 right-4 p-2 transition-all duration-300 ${
              inWishlist
                ? 'bg-gold text-black'
                : 'bg-black/40 text-white hover:bg-gold hover:text-black'
            }`}
            data-testid={`wishlist-btn-${product.id}`}
          >
            <Heart size={16} strokeWidth={1.5} fill={inWishlist ? 'currentColor' : 'none'} />
          </button>
        </div>

        {/* Product Info */}
        <div className="mt-4 space-y-2">
          <h3 className="font-heading text-base md:text-lg text-foreground group-hover:text-gold transition-colors">
            {product.name}
          </h3>
          <p className="text-xs text-foreground/50 uppercase tracking-wider">
            {product.category}
          </p>
          <p className="price-tag text-gold text-lg">
            {product.price.toFixed(2)} €
          </p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
